@if (state) {
  <div class="view-containers" [ngClass]="{'horizontal': config.orientation === 'horizontal', 'vertical': config.orientation === 'vertical'}" >
    @for (vc of state.children; track vc; let idx = $index) {
      <div class="view-wrapper" [style]="(config.orientation === 'horizontal' ? 'width: ' : 'height: ') + sizes[idx] + '%' " [id]="'split-vc-' + config.id + '-' + vc">
        <div class="view-content" viewContainerPortal [id]="'split-vc-' + config.id + '-' + idx"></div>
        @if (idx !== state.children.length - 1) {
          <div splitPortalResizer [ngClass]="config.orientation" class="resizer" ></div>
        }
      </div>
    }
  </div>
}
